import spinner from '../../assets/images/loader.gif'
import { Image } from 'react-bootstrap'

export default function Loader() {
  return (
    <div className="spinner-box"> <Image src={spinner} alt='Loading' className="spinner">
    </Image></div>
  )
}